import _FileExtractButton from './components/file-extract-button';
import _FileTriggerButton from './components/file-trigger-button';
import _FileRecordTable from './components/file-record-table';
import _FileTable from './components/file-table';
import _FileUpload from './components/file-upload';
import _File from './components/file';
import _FileName from './components/file-name';
import './styles/file-loader-hatch.less';

import {
    setFileParameters as _setFileParameters,
    getFileParameters as _getFileParameters,
    clearFileParameters as _clearFileParameters
} from './services/file-loader-service';

export const FileUpload = _FileUpload;
export const FileTable = _FileTable;
export const File = _File;
export const FileExtractButton = _FileExtractButton;
export const FileTriggerButton = _FileTriggerButton;
export const FileRecordTable = _FileRecordTable;
export const FileName = _FileName;
export const setFileParameters = _setFileParameters;
export const getFileParameters = _getFileParameters;
export const clearFileParameters = _clearFileParameters;
